var map = {
	"./pngegg.png": 1865,
	"./rwm_logo.png": 578,
	"./rwm_logo_colored.png": 4582,
	"images/pngegg.png": 1865,
	"images/rwm_logo.png": 578,
	"images/rwm_logo_colored.png": 4582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5632;